import {
  OBSERVATION_TASKS_SET,
  OBSERVATION_TASK_ADDED,
  OBSERVATION_TASK_DELETED,
  OBSERVATION_TASK_EDITED,
} from 'src/app/redux/redux-types';
import { reduxObservationTaskTypes } from 'src/types';

export const observationTaskDefaultState: reduxObservationTaskTypes.StateType = {
  observationTaskList: [],
};

export const observationTaskReducer = (
  state = observationTaskDefaultState,
  action: reduxObservationTaskTypes.ActionType,
): reduxObservationTaskTypes.StateType => {
  switch (action.type) {
    case OBSERVATION_TASKS_SET:
      return {
        ...state,
        observationTaskList: action.payload,
      };
    case OBSERVATION_TASK_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.observationTaskList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        observationTaskList: [action.payload, ...state.observationTaskList],
      };
    case OBSERVATION_TASK_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.observationTaskList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        observationTaskList: [
          ...state.observationTaskList.slice(0, updateIndex),
          action.payload,
          ...state.observationTaskList.slice(updateIndex + 1),
        ],
      };
    case OBSERVATION_TASK_DELETED:
      return {
        ...state,
        observationTaskList: state.observationTaskList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
